export const save = (code) => {
  localStorage.setItem('prefilledDiscountCode', code);
};

export const remove = () => {
  localStorage.removeItem('prefilledDiscountCode');
};

export const get = () => localStorage.getItem('prefilledDiscountCode');
